export default __webpack_public_path__ + "static/media/hadid1.48d1091b.jpg";